import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ombudsman',
  templateUrl: './ombudsman.component.html',
  styleUrls: ['./ombudsman.component.scss']
})
export class OmbudsmanComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
